export default __webpack_public_path__ + "images/uz-6e16292aee6b5262a6938af4ed24792d.svg";